/**
 * Component template (Do not modify or delete this file – only copy)
 */
 var component_services = function(args) {

  // setup args
  var services = args.services,
      items = services.querySelectorAll('.services__item'),
      bg_imgs = services.querySelectorAll('.services__bg-img'),
      firstImg = services.querySelector(`.services__bg-img--${items[0].dataset.serviceName}`);

  // validate
  if (!services) {
    console.log('Invalid services component');
    return;
  }

  /**
   * Init
   */
  function init_component_services() {
    if (firstImg) {
      firstImg.style.opacity = 1;
    }

    items.forEach(item => {
      item.addEventListener('mouseenter', () => {
        // reset bg images activeness
        items.forEach((item) => item.classList.remove('services__item--active'));
        // reset bg images visibility
        bg_imgs.forEach((img) => img.style.opacity = 0);
        // set item as active
        item.classList.add('services__item--active');
        // set corresponding bg img to visible
        services.querySelector(`.services__bg-img--${item.dataset.serviceName}`).style.opacity = 1;
      });
    });

    return;
  }
  init_component_services();

  // make the call chainable
  return this;
};
